"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createManifest = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
function createManifest(host, components, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.artifactId, artifactId = _c === void 0 ? "generate-artifact-id" : _c, namespace = _b.namespace;
    return {
        topology: {
            artifactId: artifactId,
            url: null,
        },
        environment: {},
        components: __assign({}, components.reduce(function (acc, _a) {
            var componentName = _a.componentName, extension = _a.extension, url = _a.url, part = _a.part;
            var bundleName = editor_elements_conventions_1.getBundleName({
                componentName: componentName,
                namespace: namespace,
                host: host,
                extension: extension,
                part: part,
            });
            acc[bundleName] = url;
            return acc;
        }, {})),
    };
}
exports.createManifest = createManifest;
//# sourceMappingURL=createManifest.js.map